<template>
  <Alert type="info">
    <span v-html="t(alertMessageKey)"></span>
  </Alert>
</template>

<script>
import { useI18n } from "vue-i18n";
import { Alert } from "@estaly/ui";

export default {
  components: { Alert },

  props: {
    dataSource: { type: String, required: true },
  },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  computed: {
    alertMessageKey() {
      const messages = {
        gross_sales: "gross_sales_alert_message",
        contracts: "contracts_alert_message",
        leads: "leads_alert_message",
      };
      return messages[this.dataSource] || "gross_sales_alert_message";
    },
  },
};
</script>

<i18n src="./DataSourceAlert.i18n.json"></i18n>
